module.exports = __webpack_public_path__ + "static/media/inc-tendency.ececbcd6.svg";